<template>
  <div id="app">
    <div v-if="isShowLoginForm" @click="closeLoginForm($event)" class="JY-login">
      <div class="container">
        <div class="row">
          <div class="col-sm-5 col-lg-5" style="margin: 0 auto;">
            <ul @click="showLoginForm($event)" v-loading="showLoading">
              <el-alert v-if="loginMessage" :title="loginMessage" type="error" show-icon></el-alert>
              <h2>
                <em></em>登录
              </h2>
              <li>
                <i>
                  <img src="./assets/images/user-phone.png" width="24" height="24" alt />
                </i>
                <input type="text" v-model="inputMobile" class="form-control input-sm"
                  id="phone" placeholder="登录名或手机号码" />
              </li>
              <li style="margin-bottom: 20px;">
                <i>
                  <img src="./assets/images/user-key.png" width="24" height="24" alt />
                </i>
                <input
                  type="password"
                  v-model="inputPwd"
                  class="form-control input-sm"
                  id="pwd"
                  placeholder="密码"
                />
              </li>
              <li style="border-bottom: 0;">
                <el-checkbox v-model="inputAgree">同意</el-checkbox>
                <a href="javascript:;" @click="openCondition">《嘉盈吉运无车承运人物流平台服务协议》</a>
              </li>
              <li style="border-bottom: 0;">
                <button
                  :disabled="!inputAgree"
                  @click="login()"
                  type="button"
                  class="btn btn-danger"
                  style=" width: 100%; display: block;"
                >登录</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <header>
      <div class="container" style="position: relative;">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="JY-logo">
              <i>
                <a href>
                  <img src="./assets/images/logo.png" width="402" height="37" alt />
                </a>
              </i>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 text-right JY-phone">
            <i>
              <img src="./assets/images/phone.png" width="22" height="22" alt />
            </i>免费咨询热线 - 022-2532-6184
          </div>
        </div>
        <form v-if="!isLogined" class="form-inline my-2 my-lg-0 login-home">
          <a href="javascript:;" @click="showLoginForm($event)">登录</a> &nbsp;/&nbsp;
          <router-link to="/register" style="color: #b70000;">注册</router-link>&nbsp;/&nbsp;
          <a href="http://manager.jyjy18.com" target="_black">后台管理</a>
        </form>
        <form
          v-else
          class="form-inline my-2 my-lg-0 login-home"
          style="top: 31px; right: 13px; cursor: pointer;"
        >
          <img src="./assets/images/header.png" width="24" height="24" alt />
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="color: #000;">
              个人中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人资料</el-dropdown-item>
              <el-dropdown-item
                id="profile_more_link"
                v-if="userStatus!=3&&userStatus!=1"
                command="profilemore"
              >认证信息</el-dropdown-item>
              <el-dropdown-item command="wallet">我的钱包</el-dropdown-item>
              <el-dropdown-item v-if="userType==2||userType==3" command="cars">我的车辆</el-dropdown-item>
              <el-dropdown-item command="pwd">修改密码</el-dropdown-item>
              <!-- <el-dropdown-item v-if="userType==2" command="member">我的车队</el-dropdown-item> -->
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </form>
      </div>
    </header>
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <a class="navbar-brand" href="#" style="display: none;"></a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li v-for="item in menus" :key="item.name">
              <a
                @click="goto(item)"
                :class="selNav==item.name?'sel':''"
                href="javascript:;"
              >{{item.title}}</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <router-view />
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 text-right JY-TD" style="text-align: center !important;">
            <i>
              <img src="./assets/images/logo-white.png" width="402" height="37" alt />
            </i>
            <br />
            <br />
            <i>
              <img
                src="./assets/images/TD.png"
                style="height:80px;width:80px;"
                width="80"
                height="80"
                alt
              />
            </i>
            <br/>扫码下载承运人手机版App
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center" style="font-size: 12px;">
            <p style="margin-top:10px;">
              <a href="http://www.beian.miit.gov.cn">ICP备案号：津ICP备18006419号-1</a>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center" style="font-size: 12px;">
            <p
              style="margin-top:10px;"
            >公司全称：嘉盈智慧物流（天津）有限公司&nbsp;&nbsp;地址：天津市滨海新区洞庭路2号天津国际发展大厦20层H座，300457&nbsp;&nbsp;联系电话：022-25326184</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center" style="font-size: 12px;">
            <p style="margin-top:10px;">Copyright © MyWebsite. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
    <el-dialog title="修改密码" :visible.sync="modifyPasswordDialogVisible" width="30%" center>
      <div style="padding-top: 40px;">
        <el-form ref="form" :model="passwordModel" label-width="90px">
          <el-form-item label="旧密码">
            <el-input v-model="passwordModel.OldPassword"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="passwordModel.NewPassword"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码">
            <el-input v-model="passwordModel.ConfirmNewPassword"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyPasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePassword">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="嘉盈吉运无车承运人物流平台服务协议" :visible.sync="conditionDialogVisible" width="70%" center>
      <condition :id="conditionId"></condition>
    </el-dialog>
    <iframe id="download_iframe" src style="display:none" frameborder="0"></iframe>
  </div>
</template>

<script>
import menuConfig from "./menuConfig";
import util from "./libs/util";
import api from "./api";
import condition from "./components/condition"


export default {
  components: {
    condition
  },
  name: "app",
  data() {
    return {
      conditionId: "EE0B04B1-0059-4AF7-9761-B730C8BA0218",
      conditionDialogVisible: false,
      modifyPasswordDialogVisible: false,
      passwordModel: {},
      inputMobile: "",
      inputPwd: "",
      inputAgree: false,
      loginMessage: "",
      selNav: this.$router.currentRoute.name.split(".")[0],
      isLogined: false,
      isShowLoginForm: false,
      showLoading: false,
      menus: [],
      userType: "",
      userStatus: 0
    };
  },
  methods: {
    openCondition() {
      this.conditionDialogVisible = true;
    },
    savePassword() {
      let _this = this;
      if (
        _this.passwordModel.NewPassword !=
        _this.passwordModel.ConfirmNewPassword
      ) {
        _this.$message({
          type: "error",
          message: "两次输入的密码不一致"
        });
        return;
      }
      api.savePassword(_this.passwordModel).then(res => {
        if (res.data.Succeed) {
          _this.modifyPasswordDialogVisible = false;
          _this.$message({
            type: "success",
            message: "密码修改成功，请重新登录"
          });
          _this.logout();
        } else {
          _this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },
    wallet() {
      this.$router.push("/wallet");
    },
    profile() {
      this.$router.push("/profile");
    },
    profileMore() {
      this.$router.push("/profilemore");
    },
    cars() {
      this.$router.push("/mycars");
    },
    modifyPwd() {
      this.modifyPasswordDialogVisible = true;
    },
    handleCommand(command) {
      switch (command) {
        case "profile":
          this.profile();
          break;
        case "profilemore":
          this.profileMore();
          break;
        case "logout":
          this.logout();
          break;
        case "pwd":
          this.modifyPwd();
          break;
        case "wallet":
          this.wallet();
          break;
        case "cars":
          this.cars();
          break;
      }
    },
    logout() {
      util.cookies.remove("access_token");
      util.cookies.remove("usertype");
      this.$router.push("/index");
      this.selNav = "index";
      this.isLogined = false;
      this.initMenu();
    },
    login() {
      let _this = this;
      if (!_this.inputMobile || !_this.inputPwd || !_this.inputAgree) {
        return;
      }
      _this.showLoading = true;
      api.createToken({
          mobile: _this.inputMobile,
          pwd: _this.inputPwd
        }).then(res => {
          _this.showLoading = false;
          if (res.data.Succeed) {
            util.cookies.set("access_token", res.data.Token);
            util.cookies.set("usertype", res.data.UserType);
            // document.getElementsByTagName("body")[0].style.overflow = "auto";
            // _this.isLogined = true;
            // _this.initMenu();
            // _this.isShowLoginForm = false;
            //_this.$router.push(res.data.UserType == 0 ? "shipper" : "driver");
            _this.$router.push("profile");
            window.location.reload();
          } else {
            _this.loginMessage = res.data.Message;
          }
        });
    },
    showLoginForm(event) {
      this.isShowLoginForm = true;
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      event.stopPropagation();
    },
    closeLoginForm(event) {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      this.isShowLoginForm = false;
      event.stopPropagation();
    },
    goto(page) {
      this.selNav = page.name;
      util.title(page.title);
      this.$router.push(page.path);
    },
    initMenu() {
      var access_token = util.cookies.get("access_token");
      if (access_token) {
        this.loadPermissonMenu();
      } else {
        this.loadDefaultMenu();
      }
    },
    loadPermissonMenu() {
      this.isLogined = true;
      var userType = util.cookies.get("usertype");
      var arr = menuConfig.filter(m => {
        //货主
        if (userType === "0") {
          return m.name != "driver";
        } else {
          return m.name != "shipper";
        }
      });
      this.menus = arr;
    },
    loadDefaultMenu() {
      var arr = menuConfig.filter(item => {
        return item.static == true;
      });
      this.menus = arr;
    },
    checkUserStatus() {
      let _this = this;
      if (_this.isLogined) {
        api.checkUserStatus().then(res => {
          if (res.data.Succeed) {
            _this.userStatus = res.data.Status;
            _this.userType = res.data.UserType;
            util.cookies.set("usertype", _this.userType);
          }
        });
      }
    }
  },
  mounted() {
    this.userType = util.cookies.get("usertype");
    this.initMenu();
    util.title();
    this.checkUserStatus();
  }
};
</script>

<style>
@import url("./assets/css/bootstrap-4.0.0.css");
@import url("./assets/css/JY-style.css");
@import url("./assets/css/JY-login.css");
  .JY-login {
    padding-top: 10%;
  }
  .el-dropdown {
    color: rgba(255, 255, 255, 0.6) !important;
    margin-left: 10px;
  }
  .center {
    text-align: center;
  }

  #index {
    width: 100%;
    ul {
      li {
        width: 24%;
        height: 200px;
        margin-right: 1%;
        margin-bottom: 20px;
        cursor: pointer;
        display: inline-block;
        &:nth-child(4n) {
          margin-right: 0;
        }
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue